/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/11/2021
 */
import mergeProps from "@/router/utils/mergeProps";
import redirectByName from "@/router/utils/redirectByName.js";
let EmptyRouterView = () => import(/* webpackChunkName: "PackagesModule" */ '@/core/components/EmptyRouterView.vue')
let ComingSoonPage = () => import(/* webpackChunkName: "PackagesModule" */ '@/core/recoveryCoachingApp/ComingSoonPage.vue')
let CoachingPackagesMain = () => import(/* webpackChunkName: "PackagesModule" */ '@/core/recoveryCoachingApp/coach/CoachingPackages/CoachingPackagesMain.vue')
let GroupPackagesDetails = () => import(/* webpackChunkName: "PackagesModule" */ '@/core/recoveryCoachingApp/coach/CoachingPackages/Groups/details/GroupPackagesDetails.vue')


export default [

	{
		path: 'packages',
		component: EmptyRouterView,
		props: mergeProps,
		redirect: redirectByName('CoachingPackagesMainRoute', {activeTab: 'first-tab'}),
		children: [

			{
				path: 'groups/:packageId/details/:tab?/:sharedResourceTab?',
				name: 'GroupPackageDetailsRoute',
				component: GroupPackagesDetails,
				props: mergeProps,
				meta: {
					activeTab: "groups"
				},
				children:[
				]
			},
			{
				path: ':activeTab',
				name: 'CoachingPackagesMainRoute',
				component: CoachingPackagesMain,
				props: mergeProps,
				children:[
				]
			},
		]
	},




]


